var AddToCartModal = (function($) {
  var _public = {};
  var _private = {};

  _private.item_added = {};
  _private.cart_html = '';
  _private.modal_html = '';

  _public.$catalyst_button = {};
  _private.product_handle = '';
  _private.variant_id = 0;
  _private.quantity = 1;
  _private.item_id = 0;

  _private.$cart_modal = {};

  _private.accessories_html = '';

  _public.init = function() {
    listen();
  };


  return _public;


  function listen(){

    // "Add to Cart" button clicks on product page, collection page. This launches modal
    $(document).on('click', '.add-to-cart', function(event) {
      if($(this).hasClass('is-disabled')) {
        $('#back-in-stock').slideDown(200);
        return false;
      } else {
      event.preventDefault();
      _public.$catalyst_button = $(this);
      // 1. get some necessary product data
      _private.product_handle = _public.$catalyst_button.data('handle');
      _private.variant_price = _public.$catalyst_button.closest('form').find('[name="id"]').find(':selected').data('price');
      _private.variant_id = _public.$catalyst_button.closest('form').find('[name="id"]').val();
        // 2. submit request to product.added-modal.liquid template (which is a copy of cart.liquid)
        getCartHTML(_private.product_handle);
      }
    });

    // Catch "Update" button clicks
    $(document).on('click', '.sectioncart.modal .update-cart', function(event) {
      event.preventDefault();
      updateQuantity();
    });
    // Catch "Remove" button clicks
    $(document).on('click', '.sectioncart.modal .remove-item', function(event) {
      event.preventDefault();
      var params = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + 0 + '&id=' + _private.variant_id,
        dataType: 'json',
        success: function(data) {
          document.location.href="/cart";
        },
        error: function(XMLHttpRequest, textStatus) {}
      };
      $.ajax(params);

    });
  }

  function updateQuantity() {
    var quantity = $('.sectioncart.modal input.thequantity').val();
    _private.quantity = quantity;

    // * ajax quantity update
    // * after callback, update subotal, etc.

    var params = {
      type: 'POST',
      url: '/cart/change.js',
      data:  'quantity='+_private.quantity+'&id='+_private.variant_id,
      dataType: 'json',
      success: function(cart) {
        // update item count HTML in modal
        $('.sectioncart.modal .cart-total-items').html(cart.item_count);
        // update price HTML in modal
        $('.sectioncart.modal .cart-total-price').html( formatMoney(cart.total_price) );

      },
      error: function(XMLHttpRequest, textStatus) {}
    };
    $.ajax(params);
  }

  function getCartHTML() {
    var variant_string = '';
    if (_private.variant_id) {
      variant_string = '&variant=' + _private.variant_id;
    };

    var params = {
       type: 'GET',
       url: '/products/' + _private.product_handle + '?view=added-modal' + variant_string,
       dataType: 'html',
       success: function(data) {
         _private.cart_html = data;
         assembleModalHTML();
         // update cart in background. This must be called after `product.added-modal.liquid`'s HTML is returned or we can't update values manually
         addItemViaAJAX();
       },
       error: function(XMLHttpRequest, textStatus) {}
     };
     $.ajax(params);
  }

  function assembleModalHTML() {
    var $contents = $('<div></div>');
    $contents.append(_private.cart_html);

    // transfer correct quantity to new form
    _private.quantity = parseInt( _public.$catalyst_button.closest('form').find('input[name="quantity"]').val() );

    var $quantity = $contents.find('.thequantity');
    $quantity.val(_private.quantity);

    $quantity.attr('value', _private.quantity);
    // set line price displayed based on _private.quantity
    var $line_price = $contents.find('.line-price');
    var price_per_unit = parseInt( $line_price.html().replace(/[$,.]/g, '') );
    var line_price = price_per_unit * _private.quantity;
    $line_price.html( formatMoney(line_price) );
    // update cart total price and total items via just javascript calculations first
    var $cart_total_items = $contents.find('.cart-total-items');
    var cart_total_items = parseInt( $cart_total_items.html() );
    cart_total_items += _private.quantity;
    $cart_total_items.html(cart_total_items);

    var $cart_total_price = $contents.find('.cart-total-price');


    var cart_total_price = parseInt( $cart_total_price.html().replace(/[$,.]/g, '') );
    cart_total_price += line_price;
    $cart_total_price.html( formatMoney(cart_total_price) );
    _private.modal_html = $contents.html();
    launchModal();
  }

  function addItemViaAJAX() {
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: 'quantity=' + _private.quantity + '&id=' + _private.variant_id,
      dataType: 'json',
      success: function(item_added) {
        _private.item_id = item_added.id;
      },
      error: function(XMLHttpRequest, textStatus) {}
    };
    $.ajax(params);
  }

  function addAccessoriesCarousel() {
    var carousel_selector = '.vbox-content .accessories';
    var accessories_handles = $(carousel_selector).data('products');

    if (accessories_handles.length) {
      ProductAccessoriesCarousel.init(accessories_handles, carousel_selector);
    } else {
      $('.sectioncart.modal h4.subtitle').hide();
      $('.sectioncart.modal .accessories').hide();
    }
  }

  // This function holds the specifics for loading and launching whatever lightbox plugin the current site is using
  function launchModal() {

    // For venobox, you always have to use an anchor element as a launching point. If you're trying to open with inline HTML, set attribute `data-type="inline"`.
    // Then, create another hidden element which wraps the HTML you wish to be displayed in popup. Give it a unique id.
    // Then, have href of anchor element point to id of content wrapper.
    var unique_number = Math.floor((Math.random() * 1000) + 1 );
    var anchor_selector = 'venobox-anchor-' + unique_number;
    var content_selector = 'venobox-modal-' + unique_number;

    var $anchor = $('<a id="' + anchor_selector + '" class="venobox-modal" style="display:none;" data-type="inline" href="#' + content_selector + '">&nbsp;</a>');
    // add below into dom
    var $content = $('<div id="' + content_selector + '" style="display:none;">' + _private.modal_html + '</div>' );

    $('body').append($anchor);
    $('body').append($content);

    $('.venobox-modal').venobox({
      framewidth: 'auto',
      frameheight: 'auto'
    });

    $('#' + anchor_selector).click();
    setTimeout(function() {
      _private.$cart_modal = $('.sectioncart.modal');
      addAccessoriesCarousel();
    }, 1001);
    setTimeout(function() {
      $('#' + content_selector).remove();
    }, 1000);
  }

  //-------------------
  // Utility functions
  //-------------------

  function formatMoney(cents, format) {
    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) { return 0; }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return '$' + dollars + cents;
    }

    return formatWithDelimiters(cents, 2);
  }

}(jQuery));
